import * as zod from 'zod'
import api from 'api'

export const requiresEverifySweepPreviewResponseSchema = zod.object({
  workers_affected: zod.number(),
})

export type RequiresEverifySweepPreviewResponse = zod.infer<
  typeof requiresEverifySweepPreviewResponseSchema
>

/**
 * Number of currently-scheduled, not-yet-E-Verified workers who would be
 * unscheduled from future shifts if E-Verify were required for this company.
 */
export const getRequiresEverifySweepPreview = async (companyId: number) => {
  const response = await api.get(
    `/admin/company/${companyId}/everify_sweep_preview`
  )
  return requiresEverifySweepPreviewResponseSchema.parse(response.data)
    .workers_affected
}
